module.exports = __webpack_public_path__ + "img/pay_line.c4c0c228.png";